import PropTypes from 'prop-types';
import React from 'react';

const DEFAULT_ICON_SIZE = { w: 49, h: 24 };

function SbpIconFooter({ className, w, h }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w || DEFAULT_ICON_SIZE.w}
      height={h || DEFAULT_ICON_SIZE.h}
      viewBox="0 0 49 24"
      className={className}
    >
      <path
        d="M0.295898 5.22363L3.20222 10.4185V13.5872L0.299298 18.7719L0.295898 5.22363Z"
        fill="#5B57A2"
      />
      <path
        d="M11.4551 8.52933L14.1784 6.86018L19.7518 6.85498L11.4551 11.9376V8.52933Z"
        fill="#D90751"
      />
      <path
        d="M11.4395 5.19326L11.4549 12.0711L8.54175 10.2811V0L11.4397 5.19326H11.4395Z"
        fill="#FAB718"
      />
      <path
        d="M19.7516 6.85401L14.178 6.85921L11.4395 5.19326L8.54175 0L19.7514 6.85401H19.7516Z"
        fill="#ED6F26"
      />
      <path
        d="M11.4549 18.8004V15.4635L8.54175 13.7075L8.54335 23.9988L11.4549 18.8004Z"
        fill="#63B22F"
      />
      <path
        d="M14.1715 17.1467L3.20202 10.4185L0.295898 5.22363L19.74 17.1399L14.1713 17.1467H14.1715Z"
        fill="#1487C9"
      />
      <path
        d="M8.5437 23.9998L11.4548 18.8014L14.1713 17.1474L19.7398 17.1406L8.5437 23.9998Z"
        fill="#017F36"
      />
      <path
        d="M0.299316 18.7724L8.56569 13.7086L5.78656 12.0034L3.20224 13.5878L0.299316 18.7724Z"
        fill="#984995"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.072 14.9825C33.9475 14.9825 35.3403 13.8325 35.3403 12.0892C35.3403 10.4018 34.3128 9.30627 32.5953 9.30627C31.8028 9.30627 31.1488 9.58517 30.6562 10.0666C30.7738 9.07171 31.6152 8.34517 32.5415 8.34517C32.7554 8.34517 34.3649 8.34185 34.3649 8.34185L35.2751 6.6001C35.2751 6.6001 33.2544 6.64619 32.315 6.64619C30.1686 6.68349 28.7189 8.63442 28.7189 11.0039C28.7189 13.7645 30.1328 14.9825 32.072 14.9825ZM32.0834 10.849C32.7798 10.849 33.2625 11.3066 33.2625 12.089C33.2625 12.7931 32.8336 13.3733 32.0834 13.3749C31.3658 13.3749 30.883 12.8372 30.883 12.1009C30.883 11.3183 31.3658 10.849 32.0834 10.849ZM42.5824 8.90531V14.7727H40.4873V10.6568H38.47V14.7727H36.3748V8.90492L42.5824 8.90531ZM25.7797 13.1476C26.5187 13.0937 27.0134 12.8083 27.0134 12.8083L27.7888 14.2429C27.2922 14.5618 26.4775 14.7692 25.8869 14.7911C23.774 14.8299 22.3042 13.5442 22.3042 11.6711C22.3042 9.82149 23.8679 8.50512 25.8869 8.50512C26.6869 8.50512 27.3747 8.71977 27.8911 9.11116C27.7824 9.30373 27.6346 9.57052 27.4942 9.82579L27.2693 10.2355L27.0647 10.6098C27.0647 10.6098 26.3207 10.2199 25.7583 10.2199C24.8411 10.2199 24.1732 10.7529 24.1732 11.6828C24.1732 12.6363 24.9301 13.1728 25.7797 13.1476Z"
        fill="white"
      />
    </svg>
  );
}

SbpIconFooter.ICON_SIZE = DEFAULT_ICON_SIZE;

SbpIconFooter.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  className: PropTypes.string,
};

SbpIconFooter.defaultProps = {
  className: '',
};

export default SbpIconFooter;
